const Info = function() {
  return (
    <div className="info">
      <h3>How to use:</h3>
      <ol>
        <li>Input your contact's name, workplace, email, and phone number. <span>*</span>Required field</li>
        <li>Click/press the "ADD" button.</li>
        <li>Your contact will be added into your job hunting address book below.</li>
      </ol>
    </div>
  )
}

export default Info;